module.exports = __webpack_public_path__ + "static/media/icon-in-red.d17b3677.svg";